import { ca } from '@cian/analytics';

export function trackSectionViewed(
  sectionName:
    | 'deal_place'
    | 'deal_type'
    | 'deal_process'
    | 'call_me'
    | 'personal_manager'
    | 'deal_price'
    | 'services'
    | 'webinar'
    | 'FAQ'
    | 'presentation'
    | 'basement'
    | 'contact_information',
  extra: object = {},
) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSalePromo',
    action: 'Show_sopr',
    label: sectionName,
    page: {
      ...extra,
    },
  });
}
